// capture button click
export const sidebarTabs = (currenttab) => ({
  type: "Current_Sidebar_Tab",
  payload: currenttab,
});
